import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import { PoseDetectionMetrics } from "./pose/PoseDetectionMetrics";
import "./SessionPoseMetricsDialog.css";

/**
 * First-video (or any clip) stroke metrics report from tbl_pose_metrics / detection shape.
 */
export function SessionPoseMetricsDialog({
  open,
  onClose,
  title,
  metrics,
  t = (k, d) => d || k,
}) {
  if (!open) return null;

  const detection = metrics
    ? {
        label: t("poseFhTopspin", "Forehand topspin"),
        stroke_count: metrics.stroke_count,
        essai_count: metrics.essai_count,
        rally_count: metrics.rally_count,
        rally_number: metrics.rally_number,
        rally_window_ms: metrics.rally_window_ms,
        strokes_per_essai: metrics.strokes_per_essai,
        pct_strokes_in_rallies: metrics.pct_strokes_in_rallies,
        inter_stroke_interval_ms: metrics.inter_stroke_interval_ms,
        strokes_in_rallies: metrics.strokes_in_rallies,
        amplitude_ms_min: metrics.amplitude_ms_min,
        amplitude_ms_avg: metrics.amplitude_ms_avg,
        amplitude_ms_max: metrics.amplitude_ms_max,
        shoulder_width_ref: metrics.shoulder_width_ref,
      }
    : null;

  return (
    <Dialog
      open={Boolean(open)}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      sx={{ zIndex: 13000 }}
    >
      <DialogTitle>
        {title || t("poseSessionReport", "Stroke detection report")}
        {metrics?.pose_fps != null ? (
          <span className="session-pose-metrics-dialog__subtitle">
            {t("poseAnalyzedFpsHint", `Analyzed at ${metrics.pose_fps} fps`)}
          </span>
        ) : null}
      </DialogTitle>
      <DialogContent>
        {detection ? (
          <PoseDetectionMetrics detection={detection} />
        ) : (
          <p className="session-pose-metrics-dialog__empty">
            {t("poseMetricsPending", "Metrics not ready yet.")}
          </p>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">
          {t("close", "Close")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default SessionPoseMetricsDialog;
